export default __webpack_public_path__ + "static/media/bg_7.f495bb2f.png";